import { render, staticRenderFns } from "./SettingFileManager.vue?vue&type=template&id=37d7d1e2&scoped=true&"
import script from "./SettingFileManager.vue?vue&type=script&lang=js&"
export * from "./SettingFileManager.vue?vue&type=script&lang=js&"
import style0 from "./SettingFileManager.vue?vue&type=style&index=0&id=37d7d1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7d1e2",
  null
  
)

export default component.exports